import { RefString } from "@tblabs/truffle";


export class Recruit
{
    public Name = new RefString();
    public Phone = new RefString();
    public Email = new RefString();
    public City = new RefString();

    constructor(name?: string, phone?: string, email?: string, city?: string)
    {
        if (name)
            this.Name.value = name;
        if (phone)
            this.Phone.value = phone;
        if (email)
            this.Email.value = email;
        if (city)
            this.City.value = city;
    }
}
